import { useState, useEffect } from 'react';

const useMobileDetection = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            const isSmallScreen = window.innerWidth <= 768;
            
            setIsMobile(isSmallScreen);
        };

        checkIsMobile();

        window.addEventListener('resize', checkIsMobile);
        
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    return isMobile;
};

export default useMobileDetection;
